import { filter, map } from 'underscore';
import $ from 'jquery';
import { IMPORT_TYPE } from '@bingads-webui-campaign-legacy/scheduled-import/view/import-type';

import * as constants from '@bingads-webui-campaign/import-center/src/constants/import-center-constants';

const IMPORT_API_TYPE = {
  googleimport: 'googleimport',
  facebookimport: 'facebookimport',
  amazonImport: 'amazonImport',
  pinterestImport: 'pinterestImport',
};

const CONNECTION_CONTEXT = {
  [IMPORT_API_TYPE.googleimport]: 'AdWordsImportContext',
  [IMPORT_API_TYPE.facebookimport]: 'FacebookImportContext',
  [IMPORT_API_TYPE.amazonImport]: 'AmazonImportContext',
  [IMPORT_API_TYPE.pinterestImport]: 'PinterestImportContext',
};

const IMPORT_CONNECTION_TYPE_MAP = {
  Import: 'Google',
  FacebookImport: 'Facebook',
  AmazonImport: 'Amazon',
  PinterestImport: 'Pinterest',
};

const IMPORT_CONNECTION_PREFIX = {
  Google: 'G - ',
  Facebook: 'F - ',
  Amazon: 'A - ',
  Pinterest: 'P - ',
};

// fetch one type schedule data
const fetchScheduleData = (serverContext, queryParam, importTypeOfFilter) => {
  const { cid, aid } = queryParam;
  const urlPrefixModern = aid ?
    `/Customers(${cid})/Accounts(${aid})` :
    `/Customers(${cid})`;

  let apiFilter;
  if (aid) {
    apiFilter = {
      [IMPORT_TYPE.facebookimport]: constants.FILTER_ALL_BUT_DELETED_FACEBOOK_ITEMS,
      [IMPORT_TYPE.amazonImport]: constants.FILTER_ALL_BUT_DELETED_AMAZON_ITEMS,
      [IMPORT_TYPE.pinterestImport]: constants.FILTER_ALL_BUT_DELETED_PINTEREST_ITEMS,
    }[importTypeOfFilter] || constants.FILTER_ALL_BUT_DELETED;
  } else {
    apiFilter = constants.FILTER_ALL_BUT_DELETED_MULTIACCOUNT;
  }

  const urlSearchParams = new URLSearchParams({
    $top: 5,
    $count: true,
    $filter: apiFilter,
  });
  const url = `${urlPrefixModern}/TaskItems`;
  const option = {
    contentType: 'application/json',
    type: 'GET',
    headers: {
      authorization: `CCMTSmallToken ${serverContext.Token}`,
    },
    url: `${serverContext.ServicesEndpoints.CampaignAPI}Campaign/V2${url}?${urlSearchParams}`,
  };

  return $.ajax(option);
};

// temporaly fetch sessionId from the fetch schedule grid data api 【Account level】
export const getAdsAccountConnections = (importTypePermission, serverContext, queryParam) => {
  // check permissions
  const importTypes = filter(IMPORT_API_TYPE, type => importTypePermission[type]);
  const promises = map(importTypes, importType => fetchScheduleData(serverContext, queryParam, importType)
    .then(res => ({ data: res.value, importType })));
  return Promise.all(promises)
    .then((objs) => {
      const connectionSet = new Set();
      const connectionList = [];
      map(objs, (obj) => {
        const originalConnections = obj.data;
        map(originalConnections, (originalConnection) => {
          const connection = {
            Id: originalConnection[CONNECTION_CONTEXT[obj.importType]].SessionId,
            Account: IMPORT_CONNECTION_PREFIX[IMPORT_CONNECTION_TYPE_MAP[originalConnection.Type]] + originalConnection[CONNECTION_CONTEXT[obj.importType]].AccountName,
            Type: IMPORT_CONNECTION_TYPE_MAP[originalConnection.Type],
            Status: 'Enabled',
            SessionId: originalConnection[CONNECTION_CONTEXT[obj.importType]].SessionId,
          };
          if (!connectionSet.has(connection.Account)) {
            connectionSet.add(connection.Account);
            connectionList.push(connection);
          }
        });
      });
      return connectionList;
    });
};

// MCC & Smart Account connection data
export const getMCCAccountConnections = (serverContext, queryParam) => fetchScheduleData(serverContext, queryParam).then((res) => {
  const connectionSet = new Set();
  const connectionList = [];
  map(res.value, (item) => {
    const connection = {
      Id: item.ImportTaskItemList[0].AdWordsImportContext.SessionId,
      Account: `G - ${item.ImportTaskItemList[0].AdWordsImportContext.AccountName}`,
      Type: 'Google',
      Status: 'Enabled',
      SessionId: item.ImportTaskItemList[0].AdWordsImportContext.SessionId,
    };
    if (!connectionSet.has(connection.Account)) {
      connectionSet.add(connection.Account);
      connectionList.push(connection);
    }
  });
  return connectionList;
});
